import { adapter, Service } from 'components/system';
import { CustomerSelection } from './selection';

export class CustSelectionFactory extends Service {
    static get $name() {
        return 'CustSelectionFactory';
    }

    static get $inject() {
        return ['$injector'];
    }

    constructor($injector) {
        super();
        this._$injector = $injector;
    }

    create(selectionId, options = {}) {
        const selection = new CustomerSelection(this._$injector, selectionId || 0);

        if (options.idField) {
            selection.idField = options.idField;
        }

        return selection;
    }
}

adapter.linkService(CustSelectionFactory);
